module.exports = __webpack_public_path__ + "img/cert2.b39089ce.png";